export default "__VITE_ASSET__B9JY8$VE__"